import React, { Component } from 'react';
import {connect}            from 'react-redux';

import RenderTopoPag          from '../../../container/RenderTopoPag';
import {Config}             from '../../../actions/configActions';
import {iframe }            from '../../../actions/jogosAction';
import { GetActionBg }      from '../../../actions/scopoAction';
import bg_talentos          from "../../../img/bg/bg_talentos.png";
import $ from 'jquery';

class talentos extends Component {
    
    
    componentWillMount() {
        this.props.GetActionBg(bg_talentos);
        this.renderTalentos();
        
      
    }
    componentDidUpdate(){

        $('.embed-responsive-16by9').attr('style','padding-bottom:40.25%');
    }

    renderTalentos(val){
       
      return this.props.iframe(`${Config().ip}/animacoes/talentos/${(!val?'individual':'turma')}/talentos.html`);
    }
  
    render() {
       console.log(this.props.checkSelect);
        const dados = this.renderTalentos(this.props.checkSelect);
       
        return(        
                <div className="hud-middle-center active">
                <RenderTopoPag 
                    menu1="" 
                    menu2="" 
                    titulo="Talentos"
                 />
                 <main className="hud-middle-center-content">                   
                   <div dangerouslySetInnerHTML={{__html: dados}}/>                               
                </main>
                </div>
        
          
               );
    }
}

function mapStateToProps(state) {

    return {checkSelect : state.scopoReducer.checkSelect};
}

export default connect(mapStateToProps,{iframe,GetActionBg})(talentos);

// menu1="Talentos da Nave" 
// menu2="Talentos da Tripulação" 
// titulo="Talentos"

  {/* <div className="hud-middle-center active">
                <RenderHeader titulo="talentos"/>
                <main className="hud-middle-center-content">
                <div className="container-bg">
                    <div dangerouslySetInnerHTML={{__html: this.renderTalentos()}}/> 
                             </div>             
                </main>
                </div>     */}


// WEBPACK FOOTER //
// ./src/components/aluno/talentos/talentos.js